module.exports = __webpack_public_path__ + "img/ic_add_beacon.84f7a02e.svg";